import api from '@pray/shared/utils/api';
import { ListResponse } from '@pray/shared/utils/api/types/response';

import { CreditPlanOptionResponse } from './types';

export const getCreditPlans = async () => {
  const url = '/web/studio/credits/plans';

  const response = await api.executeGetRequest<ListResponse<CreditPlanOptionResponse>>(url);

  return response.data;
};
